<template>
  <div class="dropdown">
    <!--<el-dropdown v-if="addMosaicDropdown==1">
        <el-button>
            Mosaic Outputs
            <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <template #dropdown>
            <el-dropdown-menu>
            <el-dropdown-item>Mosaic Output 1</el-dropdown-item>
            <el-dropdown-item>Mosaic Output 2</el-dropdown-item>
            <el-dropdown-item>Mosaic Output 3</el-dropdown-item>
            <el-dropdown-item>Mosaic Output 4</el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
    <el-dropdown v-else v-for="(item, index) in addMosaicDropdown" :key="index">
        <el-button>
            Mosaic Outputs {{index+1}}
            <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <template #dropdown>
            <el-dropdown-menu>
            <el-dropdown-item>Mosaic Output 1</el-dropdown-item>
            <el-dropdown-item>Mosaic Output 2</el-dropdown-item>
            <el-dropdown-item>Mosaic Output 3</el-dropdown-item>
            <el-dropdown-item>Mosaic Output 4</el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown> -->

    <el-select
      v-if="addMosaicDropdown==1"
      v-model="mosaicOutputs"
      placeholder="Mosaic Outputs"
    >
      <el-option
        v-for="(item, index) in mosaicOutputsOptions"
        :key="index"
        :value="item.addonId"
        :label="item.addonName"
      ></el-option>
    </el-select>

    <el-select
      v-else
      v-for="(item, index) in addMosaicDropdown"
      :key="index"
      v-model="mosaicOutputs"
      placeholder="Mosaic Outputs "
    >
      <el-option
        v-for="(mosaicOptionItem, mosaicOptionIndex) in mosaicOutputsOptions"
        :key="mosaicOptionIndex"
        :value="mosaicOptionItem.addonId"
        :label="mosaicOptionItem.addonName"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'MosaicOutputDropdown',
  props: {
    addMosaicDropdown: {
      type: Number
    },
    mosaicOutputsOptions: {
      type: Array
    }
  },
  data () {
    return {
      mosaicOutputs: null
      // mosaicOutputsOptions: [
      //     {
      //     value: "null",
      //     name: "Mosaic Outputs"
      //     },
      //     {
      //     value: "mosaicOutput1",
      //     name: "Mosaic Outputs 1"
      //     },{
      //     value: "mosaicOutput2",
      //     name: "Mosaic Outputs 2"
      //     },{
      //     value: "mosaicOutput3",
      //     name: "Mosaic Outputs 3"
      //     },{
      //     value: "mosaicOutput4",
      //     name: "Mosaic Outputs 4"
      //     },
      // ],

    }
  },
  methods: {

  },
  watch: {
    mosaicOutputs (value) {
      this.$emit('mosaicOutputs', value)
    }
  }
}
</script>
<style>

</style>
